<div class="lottie-wrapper">
    <ng-lottie [options]="options" width="28px" height="28px" />
</div>